import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
  Box,
  IconButton,
  Divider,
  CircularProgress,
} from "@mui/material";
import FeatherIcon from "feather-icons-react";
import LogoIcon from "../logo/LogoIcon";
import { GetLatestApplicationVersion } from "../../../services/admin";

const AboutApplicationDialog = ({ open, onClose }) => {
  const [applicationInfo, setApplicationInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const getOperatingSystem = () => {
    if (navigator.appVersion.indexOf("Win") !== -1) return "Windows";
    if (navigator.appVersion.indexOf("Mac") !== -1) return "macOS";
    if (navigator.appVersion.indexOf("X11") !== -1) return "UNIX";
    if (navigator.appVersion.indexOf("Linux") !== -1) return "Linux";
    return "Unknown OS";
  };

  const getBrowser = () => {
    const ua = navigator.userAgent;

    if (ua.indexOf("Firefox") > -1) return "Mozilla Firefox";
    if (ua.indexOf("Opera") > -1 || ua.indexOf("OPR") > -1) return "Opera";
    if (ua.indexOf("Edg") > -1) return "Microsoft Edge";
    if (ua.indexOf("Chrome") > -1) return "Google Chrome";
    if (ua.indexOf("Safari") > -1) return "Apple Safari";

    return "Unknown Browser";
  };

  useEffect(() => {
    if (!open) return;

    if (applicationInfo) return;

    const loadApplicationInfo = async () => {
      try {
        setLoading(true);

        const response = await GetLatestApplicationVersion();

        setApplicationInfo(response.data);
      } catch (error) {
        console.error("Failed to load application information.", error);
      } finally {
        setLoading(false);
      }
    };

    loadApplicationInfo();
  }, [open, applicationInfo]);

  const InfoRow = ({ label, value }) => (
    <>
      <Grid container spacing={1}>
        <Grid item xs={5}>
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
        </Grid>

        <Grid item xs={7}>
          <Typography variant="body2" fontWeight={600}>
            {value || "-"}
          </Typography>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1 }} />
    </>
  );

    return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center" gap={1}>
            <FeatherIcon icon="info" size={20} />
            <Typography variant="h6">
              About Application
            </Typography>
          </Box>

          <IconButton onClick={onClose}>
            <FeatherIcon icon="x" size={18} />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent dividers>

        <Box textAlign="center" mb={3}>
          <LogoIcon />

          <Typography variant="h5" fontWeight={700} gutterBottom>
            {applicationInfo?.applicationName || "SSWhite Unified ERP"}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            <em>
            One Platform, Every Department, Every Process.
            </em>
          </Typography>
        </Box>

        {loading ? (
          <Box textAlign="center">
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Typography
              variant="subtitle1"
              fontWeight={700}
              gutterBottom
            >
              System Summary
            </Typography>

            <InfoRow
              label="Version"
              value={applicationInfo?.versionNumber}
            />

            <InfoRow
              label="Release"
              value={applicationInfo?.releaseName}
            />

            <InfoRow
              label="Build Number"
              value={applicationInfo?.buildNumber}
            />

            <InfoRow
              label="Environment"
              value={applicationInfo?.environment}
            />

            <InfoRow
              label="Deployment Date"
              value={applicationInfo?.deploymentDate}
            />


            <InfoRow
              label="Operating System"
              value={getOperatingSystem()}
            />

            <InfoRow
              label="Browser"
              value={getBrowser()}
            />
          </>
        )}

        <Box mt={3}>
          <Divider />

          <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            mt={2}
          >
            © {new Date().getFullYear()} S.S. White Technologies Inc.
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            align="center"
          >
            All rights reserved.
          </Typography>
        </Box>

      </DialogContent>
    </Dialog>
  );
};

export default AboutApplicationDialog;